<template>
  <div>
    <div style="margin: 10px 0;">
      <Form
        inline
        :label-width="100"
      >
        <FormItem
          label="当前选中项目"
          required
        >
          <Input
            type="text"
            v-model="selectedProjectName"
            readonly
            style="width:400px;"
            placeholder="请从下面的搜索项目中选择项目"
          ></Input>
        </FormItem>
        <FormItem
          label="重招次数"
          :label-width="80"
          required
        >
          <Select
            v-model="againValue"
            style="width:80px;"
          >
            <Option
              v-for="againTime in againTimes"
              :value="againTime.value"
            >{{againTime.label}}</Option>
          </Select>
          <Button
            size="small"
            style="margin-left:10px;"
            type="primary"
            @click="confirmProject"
          >确定</Button>
        </FormItem>
      </Form>
    </div>
    <div class="search">
      <span>项目名称：</span>
      <Input
        type="text"
        v-model="searchValue.projectName"
        style="width:160px;margin-right:10px;"
      ></Input>
      <span>项目编号全称：</span>
      <Input
        type="text"
        v-model="searchValue.projectFull"
        style="width:140px;margin-right:10px;"
      ></Input>
      <span>项目简编：</span>
      <Input
        type="text"
        v-model="searchValue.projectShort"
        style="width:100px;margin-right:10px;"
      ></Input>
      <Button
        type="primary"
        @click="searchProject"
        size="small"
      >搜索</Button>
    </div>
    <Table
      :columns="projectColumns"
      :data="projectData"
      style="margin-top:10px;"
    ></Table>
    <Page
      :page-size="3"
      :total="projectTotal"
      ref="page"
      @on-change="pageChange"
      style="margin-top: 10px;"
    ></Page>
  </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
import requestUrls from '@/lib/requestUrls'
import ajax from '@/lib/ajax'

export default {
  props: {
    visibleChange: {
      default: false
    }
  },
  data() {
    return {
      searchNum: '',
      searchValue: {
        projectName: '',
        projectFull: '',
        projectShort: '',
      },
      projectData: [],
      projectColumns: [
        {
          title: '项目名称',
          key: 'projectName'
        },
        {
          title: '项目编号全称',
          key: 'projectFull',
          width: 180
        },
        {
          title: '操作',
          width: 100,
          render: (h, params) => {
            return h('div', {
              style: {
                textAlign: 'center'
              }
            }, [
                h('Button', {
                  props: {
                    size: 'small',
                    type: 'primary'
                  },
                  on: {
                    click: () => {
                      this.projectChoosed(params.row)
                    }
                  }
                }, '选择')
              ])
          }
        },
      ],
      projectTotal: 0,
      selectedProject: '',
      selectedProjectName: '',
      againTimes: [
        { value: 'A', label: '1' },
        { value: 'B', label: '2' },
        { value: 'C', label: '3' },
        { value: 'D', label: '4' },
        { value: 'E', label: '5' },
        { value: 'F', label: '6' },
        { value: 'G', label: '7' },
        { value: 'H', label: '8' },
        { value: 'I', label: '9' },
      ],
      againValue: ''
    }
  },
  methods: {
    searchProject() {
      if (this.searchValue.projectName === '' && this.searchValue.projectFull === '' && this.searchValue.projectShort === '') {
        this.$Message.info('请输入搜索条件')
        return
      }
      this.getProject(1, this.searchValue)
    },
    async getProject(page, { projectName = '', projectFull = '', projectShort = '' }) {
      let searName = projectName ? ` and projectName.Contains("${projectName}")` : ''
      let searFull = projectFull ? ` and projectFull.Contains("${projectFull}")` : ''
      let searShort = projectShort ? ` and projectShort.Contains("${projectShort}")` : ''
      let querySear = searName + searFull + searShort
      querySear = querySear.slice(5)
      let rep = await ajax.get(requestUrls.ClProjectDb.getPaged, {
        params: {
          filter: querySear,
          sorting: 'newProjectTime desc',
          maxResultCount: 3,
          skipCount: (page - 1) * 3
        }
      })
      if (page === 1) {
        this.$refs.page.currentPage = 1
      }
      if (rep.data.success) {
        this.projectData = rep.data.result.items
        this.projectTotal = rep.data.result.totalCount
      }
    },
    projectChoosed(project) {
      this.selectedProject = project
      this.selectedProjectName = project.projectName
    },
    pageChange(page) {
      this.getProject(page, this.searchValue)
    },
    async confirmProject() {
      // 内容输入判定
      if (this.selectedProjectName === '') {
        this.$Message.error('请选择项目')
        return
      }
      if (this.againValue == undefined || this.againValue === '') {
        this.$Message.error('请选择重招次数')
        return
      }

      // 是否重招原项目判定
      let fullNum = this.selectedProject.projectFull
      let againEn = 'ABCDEFGHIJ'
      let judgeStr = fullNum.slice(-1)
      if (againEn.indexOf(judgeStr) !== -1) {
        this.$Message.error('请选择重招原项目')
        return
      }

      // 重招次数判定
      let againNumFull = this.selectedProject.projectFull + this.againValue
      let againNumAbbr = this.selectedProject.projectShort + this.againValue
      let rep = await ajax.get('/api/services/app/ClProjectDb/GetPagedWithoutRole', {
        params: {
          filter: `projectShort=="${againNumAbbr}" and projectState != "项目取消"`
        }
      })
      if (rep.data.result.totalCount === 0) {
        // 形成格式数据
        const projectData = this.selectedProject
        const data = {
          baseinfo: {
            apartment: projectData.district,
            area: projectData.area,
            projectabbr: againNumAbbr,
            projectnumfull: againNumFull,
            localnum: projectData.localNumber,
            projectname: projectData.projectName,
            manager: projectData.am,
            protime: projectData.newProjectTime,
            prostatus: '等待用户需求',
            proassistant: projectData.aid,
            proorigin: '内网立项',
            childcompany: projectData.companyName,
            comment: projectData.comment
          },
          category: {
            business: projectData.businessType,
            platform: projectData.bidPlatform,
            projectnature: projectData.projectProperty,
            cgtype: projectData.buyerNature,
            fundsprovid: projectData.capitalSource,
            cgmethod: projectData.buyerModes,
            // projectinvit: projectData,
            importproduct: projectData.import,
            argument: projectData.argument,
            package: projectData.groupCount + '',
            cgcontent: projectData.purchaseContent,
            separation: projectData.separation,
            finance: projectData.sendOrders
          },
          cgrinfo: {
            customername: projectData.specialCustomer,
            branch: projectData.branchName,
            cgrname: projectData.purchaserName,
            cgrid: projectData.purchaserId,
            address: projectData.pAddress,
            telephone: projectData.pTel,
            contact: projectData.pContacts,
            cgrtype: projectData.pAttr,
            industry: projectData.clientSys,
          },
          budget: {
            eligibility: projectData.qualifyPredict,
            budgetamount: projectData.purchaseBudget + '',
            servicetype: projectData.serviceFeeType,
            servicediscount: projectData.discount,
            expectcharge: projectData.servicePredict,
            intermediary: projectData.intermediary
          },
          workflow: { title: '' }
        }

        // 导入数据，不做保存
        this.$emit('importProject', data)

      } else {
        this.$Message.error('重招次数错误，请重新选择')
      }
    }
  },
  watch: {
    visibleChange(val) {
      if (!val) {
        this.searchNum = ''
        this.againValue = ''
        this.selectedProjectName = ''
        this.selectedProject = ''
        this.projectData = []
      }
    }
  }
}
</script>
